import { render, staticRenderFns } from "./Year02.vue?vue&type=template&id=18083408&scoped=true&"
import script from "./Year02.vue?vue&type=script&lang=js&"
export * from "./Year02.vue?vue&type=script&lang=js&"
import style0 from "./Year02.vue?vue&type=style&index=0&id=18083408&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18083408",
  null
  
)

export default component.exports